export const Parameters = [
  {
    DocumentID: 1,
    DimensionID: 1,
    FirstGroupID: 3,
    ParameterName: "KRA",
    ParameterShortName: "kra",
    ParameterDescription: `Lorem ipsum dolor sit amet, consectetur adipiscing elit. Cras est turpis, auctor a 
        enim non, ullamcorper commodo turpis. Suspendisse efficitur metus non nunc vulputate, vel feugiat 
        metus egestas. Nunc ornare mauris et dignissim lobortis. Donec tempor diam ut elit ultrices, sed 
        pulvinar ex consectetur.`,
    ParameterUOM: "Bytes",
  },
  {
    DocumentID: 2,
    DimensionID: 1,
    FirstGroupID: 3,
    ParameterName: "KPI",
    ParameterShortName: "kpi",
    ParameterDescription: `Lorem ipsum dolor sit amet, consectetur adipiscing elit. Cras est turpis, auctor a 
        enim non, ullamcorper commodo turpis. Suspendisse efficitur metus non nunc vulputate, vel feugiat 
        metus egestas. Nunc ornare mauris et dignissim lobortis. Donec tempor diam ut elit ultrices, sed 
        pulvinar ex consectetur.`,
    ParameterUOM: "Short",
  },
  {
    DocumentID: 3,
    DimensionID: 1,
    FirstGroupID: 3,
    ParameterName: "Values",
    ParameterShortName: "values",
    ParameterDescription: `Lorem ipsum dolor sit amet, consectetur adipiscing elit. Cras est turpis, auctor a 
        enim non, ullamcorper commodo turpis. Suspendisse efficitur metus non nunc vulputate, vel feugiat 
        metus egestas. Nunc ornare mauris et dignissim lobortis. Donec tempor diam ut elit ultrices, sed 
        pulvinar ex consectetur.`,
    ParameterUOM: "Int",
  },
  {
    DocumentID: 4,
    DimensionID: 1,
    FirstGroupID: 4,
    ParameterName: "Potential",
    ParameterShortName: "potential",
    ParameterDescription: `Lorem ipsum dolor sit amet, consectetur adipiscing elit. Cras est turpis, auctor a 
        enim non, ullamcorper commodo turpis. Suspendisse efficitur metus non nunc vulputate, vel feugiat 
        metus egestas. Nunc ornare mauris et dignissim lobortis. Donec tempor diam ut elit ultrices, sed 
        pulvinar ex consectetur.`,
    ParameterUOM: "Bytes",
  },
  {
    DocumentID: 5,
    DimensionID: 1,
    FirstGroupID: 4,
    ParameterName: "Capability",
    ParameterShortName: "power",
    ParameterDescription: `Lorem ipsum dolor sit amet, consectetur adipiscing elit. Cras est turpis, auctor a 
        enim non, ullamcorper commodo turpis. Suspendisse efficitur metus non nunc vulputate, vel feugiat 
        metus egestas. Nunc ornare mauris et dignissim lobortis. Donec tempor diam ut elit ultrices, sed 
        pulvinar ex consectetur.`,
    ParameterUOM: "Short",
  },
  {
    DocumentID: 6,
    DimensionID: 1,
    FirstGroupID: 4,
    ParameterName: "Skills",
    ParameterShortName: "tech stacks",
    ParameterDescription: `Lorem ipsum dolor sit amet, consectetur adipiscing elit. Cras est turpis, auctor a 
        enim non, ullamcorper commodo turpis. Suspendisse efficitur metus non nunc vulputate, vel feugiat 
        metus egestas. Nunc ornare mauris et dignissim lobortis. Donec tempor diam ut elit ultrices, sed 
        pulvinar ex consectetur.`,
    ParameterUOM: "Int",
  },
  {
    DocumentID: 7,
    DimensionID: 1,
    FirstGroupID: 5,
    ParameterName: "Behavior",
    ParameterShortName: "important",
    ParameterDescription: `Lorem ipsum dolor sit amet, consectetur adipiscing elit. Cras est turpis, auctor a 
        enim non, ullamcorper commodo turpis. Suspendisse efficitur metus non nunc vulputate, vel feugiat 
        metus egestas. Nunc ornare mauris et dignissim lobortis. Donec tempor diam ut elit ultrices, sed 
        pulvinar ex consectetur.`,
    ParameterUOM: "Int",
  },
  {
    DocumentID: 8,
    DimensionID: 1,
    FirstGroupID: 5,
    ParameterName: "Projects",
    ParameterShortName: "count",
    ParameterDescription: `Lorem ipsum dolor sit amet, consectetur adipiscing elit. Cras est turpis, auctor a 
        enim non, ullamcorper commodo turpis. Suspendisse efficitur metus non nunc vulputate, vel feugiat 
        metus egestas. Nunc ornare mauris et dignissim lobortis. Donec tempor diam ut elit ultrices, sed 
        pulvinar ex consectetur.`,
    ParameterUOM: "Bytes",
  },
  {
    DocumentID: 9,
    DimensionID: 1,
    FirstGroupID: 5,
    ParameterName: "Honors",
    ParameterShortName: "enough papers",
    ParameterDescription: `Lorem ipsum dolor sit amet, consectetur adipiscing elit. Cras est turpis, auctor a 
        enim non, ullamcorper commodo turpis. Suspendisse efficitur metus non nunc vulputate, vel feugiat 
        metus egestas. Nunc ornare mauris et dignissim lobortis. Donec tempor diam ut elit ultrices, sed 
        pulvinar ex consectetur.`,
    ParameterUOM: "Short",
  },
  {
    DocumentID: 10,
    DimensionID: 1,
    FirstGroupID: 5,
    ParameterName: "License",
    ParameterShortName: "cars",
    ParameterDescription: `Lorem ipsum dolor sit amet, consectetur adipiscing elit. Cras est turpis, auctor a 
        enim non, ullamcorper commodo turpis. Suspendisse efficitur metus non nunc vulputate, vel feugiat 
        metus egestas. Nunc ornare mauris et dignissim lobortis. Donec tempor diam ut elit ultrices, sed 
        pulvinar ex consectetur.`,
    ParameterUOM: "Int",
  },
  {
    DocumentID: 11,
    DimensionID: 1,
    FirstGroupID: 6,
    ParameterName: "Speed",
    ParameterShortName: "counts",
    ParameterDescription: `Lorem ipsum dolor sit amet, consectetur adipiscing elit. Cras est turpis, auctor a 
        enim non, ullamcorper commodo turpis. Suspendisse efficitur metus non nunc vulputate, vel feugiat 
        metus egestas. Nunc ornare mauris et dignissim lobortis. Donec tempor diam ut elit ultrices, sed 
        pulvinar ex consectetur.`,
    ParameterUOM: "Bytes",
  },
  {
    DocumentID: 12,
    DimensionID: 1,
    FirstGroupID: 6,
    ParameterName: "Mileage",
    ParameterShortName: "required",
    ParameterDescription: `Lorem ipsum dolor sit amet, consectetur adipiscing elit. Cras est turpis, auctor a 
        enim non, ullamcorper commodo turpis. Suspendisse efficitur metus non nunc vulputate, vel feugiat 
        metus egestas. Nunc ornare mauris et dignissim lobortis. Donec tempor diam ut elit ultrices, sed 
        pulvinar ex consectetur.`,
    ParameterUOM: "Short",
  },
  {
    DocumentID: 13,
    DimensionID: 1,
    FirstGroupID: 6,
    ParameterName: "Shades",
    ParameterShortName: "not required",
    ParameterDescription: `Lorem ipsum dolor sit amet, consectetur adipiscing elit. Cras est turpis, auctor a 
        enim non, ullamcorper commodo turpis. Suspendisse efficitur metus non nunc vulputate, vel feugiat 
        metus egestas. Nunc ornare mauris et dignissim lobortis. Donec tempor diam ut elit ultrices, sed 
        pulvinar ex consectetur.`,
    ParameterUOM: "Int",
  },
  {
    DocumentID: 14,
    DimensionID: 1,
    FirstGroupID: 0,
    ParameterName: "Weight",
    ParameterShortName: "important",
    ParameterDescription: `Lorem ipsum dolor sit amet, consectetur adipiscing elit. Cras est turpis, auctor a 
        enim non, ullamcorper commodo turpis. Suspendisse efficitur metus non nunc vulputate, vel feugiat 
        metus egestas. Nunc ornare mauris et dignissim lobortis. Donec tempor diam ut elit ultrices, sed 
        pulvinar ex consectetur.`,
    ParameterUOM: "Short",
  },
  {
    DocumentID: 15,
    DimensionID: 1,
    FirstGroupID: 0,
    ParameterName: "Height",
    ParameterShortName: "ok",
    ParameterDescription: `Lorem ipsum dolor sit amet, consectetur adipiscing elit. Cras est turpis, auctor a 
        enim non, ullamcorper commodo turpis. Suspendisse efficitur metus non nunc vulputate, vel feugiat 
        metus egestas. Nunc ornare mauris et dignissim lobortis. Donec tempor diam ut elit ultrices, sed 
        pulvinar ex consectetur.`,
    ParameterUOM: "Int",
  },
];
